const initialState = {
  topics: [],
  currentEventDetail: null,
  allTableDisable: false,
  masterTableEnable: false
};

const nextWeekEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NEXT_WEEK_EVENTS":
      return {
        ...state,
        topics: action.payload || [],
      };
    case "GET_CURRENT_WEEK_EVENT":
      return {
        ...state,
        currentEventDetail: action.payload,
      };
    case "DISABLE_TABLES":
      return {
        ...state,
        allTableDisable: action.payload,
      };
    case "ADD_MASTER_TABLE":
      return {
        ...state,
        masterTableEnable: action.payload,
      };
    case "EVENT_SETTINGS":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default nextWeekEventReducer;